import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable} from 'rxjs';
import { HttpParams } from '@angular/common/http';
import {RequestMetadata} from '~utils/request-metadata';
import {RotaVo} from '~model/vo/rota-vo';
import {emptyVersion, VersionVo} from '~model/vo/version-vo';
import {CardGroupVo} from '~model/vo/card-group-vo';
import {DashboardVo, emptyDashboard} from '~model/vo/dashboard-vo';

@Injectable({
  providedIn: 'root',
})
export class MonitoramentoService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = '';

  getRotas(data?: string): Observable<RotaVo[]> {
    const paramns: RequestMetadata = data !== '' ?
      {paramns: new HttpParams().append('data', data || '')} :
      {};

    return super.get<RotaVo[]>(paramns).pipe(this.defaultCatchList());
  }

  getDatas(): Observable<string[]> {
    return super.get<string[]>({extraUrl: 'datas'}).pipe(this.defaultCatchList());
  }

  getIndicadores(data?: string): Observable<CardGroupVo[]> {
    const paramns = data !== '' ? new HttpParams().append('data', data || '') : undefined;

    return super.get<CardGroupVo[]>({extraUrl: 'indicadores', paramns}).pipe(this.defaultCatchList());
  }

  getDashboard(data?: string): Observable<DashboardVo> {
    const paramns = data !== '' ? new HttpParams().append('data', data || '') : undefined;

    return super.get<DashboardVo>({extraUrl: 'dashboard', paramns}).pipe(this.defaultCatch(emptyDashboard()));
  }

  getVersions(data: string): Observable<VersionVo> {
    return super.get<VersionVo>({extraUrl: this.mountUrl('versions', data)}).pipe(this.defaultCatch(emptyVersion()));
  }

  getSseId<T extends {id: string}>(): Observable<T> {
    return super.get<T>({extraUrl: 'sse-id', paramns: null, objEnvio: null, maxRetryAttempts: 100}).pipe(this.defaultCatch());
  }
}










